// reducer
import { default as reducer } from "./reducer";

export { setSuggestionsSearchText, setSearchText, fetchFilterDefinitions, setFilterSetting, submitSearchTab } from "./actions";

export { getMainSearchSuggestionResultsStates, getMainSearchResultsStates, getMainSearchText } from "./selectors";
export default reducer;
